var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "separation-element-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "line-color" } }, [
        _vm._v(_vm._s(_vm.$t("form.lineColor"))),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separationColor,
            expression: "item.separationElement.separationColor",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "color", id: "line-color" },
        domProps: { value: _vm.item.separationElement.separationColor },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separationColor",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparationColor(
                _vm.item.separationElement.separationColor
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.separatorColorInfo"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "element-height" } },
        [_vm._v(_vm._s(_vm.$t("form.separatorHeight")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separatorHeight,
            expression: "item.separationElement.separatorHeight",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "number", id: "element-height" },
        domProps: { value: _vm.item.separationElement.separatorHeight },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separatorHeight",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparatorHeight(
                _vm.item.separationElement.separatorHeight
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.separatorHeightInfo"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "bottom-margin" } },
        [_vm._v(_vm._s(_vm.$t("form.bottomSpace")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separatorBottom,
            expression: "item.separationElement.separatorBottom",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "number", id: "bottom-margin" },
        domProps: { value: _vm.item.separationElement.separatorBottom },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separatorBottom",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparatorBottom(
                _vm.item.separationElement.separatorBottom
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.bottomSpaceInfo"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "top-margin" } }, [
        _vm._v(_vm._s(_vm.$t("form.topSpace"))),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separatorTop,
            expression: "item.separationElement.separatorTop",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "number", id: "top-margin" },
        domProps: { value: _vm.item.separationElement.separatorTop },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separatorTop",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparatorTop(
                _vm.item.separationElement.separatorTop
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.topSpaceInfo"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "side-margin" } },
        [_vm._v(_vm._s(_vm.$t("form.sideSpace")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.separationElement.separatorSide,
            expression: "item.separationElement.separatorSide",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "number", id: "side-margin" },
        domProps: { value: _vm.item.separationElement.separatorSide },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.item.separationElement,
                "separatorSide",
                $event.target.value
              )
            },
            function ($event) {
              return _vm.setSeparatorSide(
                _vm.item.separationElement.separatorSide
              )
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.sideSpaceInfo"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toggle", on: { click: _vm.toggleVisibility } },
        [
          _c(
            "span",
            { staticClass: "toggle-option", class: { active: _vm.visibility } },
            [_vm._v(_vm._s(_vm.visibility ? "Görünür" : "Gizli"))]
          ),
        ]
      ),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Bu alanın form üzerinde görünür olup olmayacağını belirler"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "slug-input" } }, [
        _vm._v("URL Parametresi"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.slug,
            expression: "slug",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "slug-input",
          placeholder: "separationElement",
        },
        domProps: { value: _vm.slug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.slug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı"),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }